export const fonts = {
  heading: "Inter, Roboto",
  body: "Inter, Roboto",
};
